/**
 * @param {string} str
 * @returns {string}
 */
export const base64Decode = (str) => {
    // @NOTE padded.base64 -> base64, можно почитать тут https://datatracker.ietf.org/doc/html/rfc4648#section-5
    const strBase64 = str.replace(/-/g, '+').replace(/_/g, '/');
    const codes = atob(strBase64)
        .split('')
        .map((v) => v.codePointAt(0));
    const bytes = new Uint8Array(codes);
    const decoder = new TextDecoder();
    return decoder.decode(bytes);
};
/**
 * @param {string} str
 * @returns {string}
 */
export const base64Encode = (str) => {
    const encoder = new TextEncoder();
    const bytes = encoder.encode(str);
    const codes = String.fromCodePoint(...bytes);
    return btoa(codes);
};
